<template>
  <transition name="message-fade">
    <div
      v-if="visible"
      :class="[
        'message',
        `message--${type}`,
        center ? 'is-center' : ''
      ]"
      :style="positionStyle"
    >
      <i :class="iconClass"></i>
      <p class="message__content">{{ message }}</p>
      <i
        v-if="showClose"
        class="message__closeBtn"
        @click="close"
      >×</i>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Message',
  data() {
    return {
      visible: false,
      message: '',
      duration: 3000,
      type: 'info',
      showClose: false,
      center: false,
      onClose: null,
      timer: null,
      offset: 2
    }
  },
  computed: {
    iconClass() {
      const iconMap = {
        success: 'message-icon-success',
        error: 'message-icon-error',
        warning: 'message-icon-warning',
        info: 'message-icon-info'
      }
      return iconMap[this.type] || iconMap.info
    },
    positionStyle() {
      return {
        top: `${this.offset}rem`
      }
    }
  },
  mounted() {
    this.startTimer()
  },
  beforeDestroy() {
    this.clearTimer()
  },
  methods: {
    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          this.close()
        }, this.duration)
      }
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },
    close() {
      this.clearTimer() // 确保清除定时器
      this.visible = false
      if (typeof this.onClose === 'function') {
        this.onClose()
      }
      this.$nextTick(() => {
        this.$destroy()
        if (this.$el && this.$el.parentNode) {
          this.$el.parentNode.removeChild(this.$el)
        }
      })
    }
  }
}
</script>

<style scoped>
.message {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  /* min-width: 380px; */
  max-width: 80%;
  word-break: break-all;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: opacity 0.3s, transform 0.4s, top 0.4s;
  overflow: hidden;
  padding: .1rem .15rem;
  display: flex;
  align-items: center;
  z-index: 9999;
}

.message.is-center {
  justify-content: center;
}

.message--success {
  background-color: #f0f9ff;
  border-color: #c6f7d0;
}

.message--error {
  background-color: #fef0f0;
  border-color: #fbc4c4;
}

.message--warning {
  background-color: #fdf6ec;
  border-color: #f5dab1;
}

.message--info {
  background-color: #f4f4f5;
  border-color: #e9e9eb;
}

.message__content {
  padding: 0;
  margin: 0;
  margin-left: 10px;
  font-size: 14px;
  line-height: 1;
}

.message--success .message__content {
  color: #67c23a;
}

.message--error .message__content {
  color: #f56c6c;
}

.message--warning .message__content {
  color: #e6a23c;
}

.message--info .message__content {
  color: #909399;
}

.message__closeBtn {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #c0c4cc;
  font-size: 16px;
  font-style: normal;
}

.message__closeBtn:hover {
  color: #909399;
}

/* 图标样式 */
.message-icon-success::before {
  content: '✓';
  color: #67c23a;
  font-weight: bold;
  font-size: 16px;
}

.message-icon-error::before {
  content: '✗';
  color: #f56c6c;
  font-weight: bold;
  font-size: 16px;
}

.message-icon-warning::before {
  content: '⚠';
  color: #e6a23c;
  font-weight: bold;
  font-size: 16px;
}

.message-icon-info::before {
  content: 'ℹ';
  color: #909399;
  font-weight: bold;
  font-size: 16px;
}

/* 动画效果 */
.message-fade-enter-active {
  transition: all 0.3s ease;
}

.message-fade-leave-active {
  transition: all 0.3s ease;
}

.message-fade-enter {
  transform: translateX(-50%) translateY(-100%);
  opacity: 0;
}

.message-fade-leave-to {
  transform: translateX(-50%) translateY(-100%);
  opacity: 0;
}
</style>